import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';
import { SelfAssessmentT2ListDto } from 'src/app/core/models/self-assessmentT2/self-assessmentT2-list-dto';
import { SelfAssessmentT3FilterModel } from 'src/app/core/models/self-assessmentT3/SelfAssessmentT3Filter';
import {
  SelfAssessmentT3ListDto,
  SelfAssessmentT3ViewModel,
} from 'src/app/core/models/self-assessmentT3/SelfAssessmentT3ViewModel';
import { SelfAssessmentT3Filter } from 'src/app/core/models/self-assessmentT3/selft-assessmentT3-filter';
import { UserProfile } from 'src/app/core/models/user';
import { ItemActiveModel } from 'src/app/core/models/view-model/item-acive-model';
import { SelfAssessmentT3ColumnModel } from 'src/app/core/models/view-model/self-assessment-column-model';
import { CommonService } from 'src/app/core/services/common/common.service';
import { GlobalService } from 'src/app/core/services/global/global.service';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { MasterHelper } from 'src/app/core/utilities';

@Component({
  selector: 'app-self-assessment-t3-summary',
  templateUrl: './self-assessment-t3-summary.component.html',
  styleUrls: ['./self-assessment-t3-summary.component.scss'],
})
export class SelfAssessmentT3SummaryComponent implements OnInit {
  selfAssessmentT3Filter: SelfAssessmentT3FilterModel =
    new SelfAssessmentT3FilterModel();
  selfAssessmentList: Array<SelfAssessmentT3ListDto>;
  myInnerHeight: any;
  endIndex = 0;
  selectedItems: Array<number>;
  newSAItemId: number;
  selectedItemId = 0;
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;
  @Input() selfAssessmentT3FilterData: SelfAssessmentT3Filter =
    new SelfAssessmentT3Filter();
  @Output() selectData = new EventEmitter<Array<any>>();
  @Input() selfAssessmentT3ColumnModel: SelfAssessmentT3ColumnModel =
    new SelfAssessmentT3ColumnModel();
  @ViewChild('tableContentT3', { read: ElementRef })
  public tableContentT3: any;
  tableWidthT3: number = 2420;
  userProfile: UserProfile;
  assesment3Type = '_sacol3';
  idList:number[] =[];
  constructor(
    public commonService: CommonService,
    private selfAssessmentTemplate3Service: SelfAssessmentTemplate3Service,
    private eleRef: ElementRef,
    public _globalService: GlobalService,
    public dialog: MatDialog,
    private router: Router
  ) {
    this._globalService.gearSaT3Call$.subscribe((data: any) => {
      this.changeSaT3TableWidth(
        data.itemWidth,
        data.isHide,
        data.filter,
        data.itemActiveModelT3
      );
    });
    this.myInnerHeight = window.innerHeight - 280;
    this.selfAssessmentList = [];
    this.selectedItems = [];
    this.newSAItemId = 0;
    this.userProfile = new UserProfile();
  }
  filterT3PersistenceKey = 'selfAssessmentT3Filters';
  fetchFromBrowser() {
    return localStorage.getItem(this.filterT3PersistenceKey);
  }
  async ngOnInit(): Promise<void> {
    var persistFilter = JSON.parse(
      this.fetchFromBrowser() as string
    ) as SelfAssessmentT3Filter;
    if (persistFilter) {
      this.selfAssessmentT3FilterData = persistFilter;
    }
    this.userProfile = await this._globalService.getLoginUserData();
    this.selfAssessmentT3Filter.jurisdictionId =
      this.userProfile.lastUsedJurisdictionId;
    if (
      this.selfAssessmentT3FilterData.fromDate != null &&
      this.selfAssessmentT3FilterData.fromDate != ''
    ) {
      this.selfAssessmentT3Filter.fromDate = new Date(
        this.selfAssessmentT3FilterData.fromDate
      );
    }
    this.selfAssessmentT3Filter.toDate = new Date(
      this.selfAssessmentT3FilterData.toDate
    );
    this.selfAssessmentT3Filter.assessmentStatus.push(
      this.selfAssessmentT3FilterData.assessmentStatus.toString()
    );
    this.selfAssessmentT3Filter.owner = this.selfAssessmentT3FilterData.owner;
    this.selfAssessmentT3Filter.complianceStatus.push(
      this.selfAssessmentT3FilterData.complianceStatus.toString()
    );
    if (this.selfAssessmentT3FilterData.reviewDate != null) {
      this.selfAssessmentT3Filter.reviewDate = new Date(
        this.selfAssessmentT3FilterData.reviewDate
      );
    }
    if (this.selfAssessmentT3FilterData.nextassessmentDue != null) {
      this.selfAssessmentT3Filter.nextAssessmentDue = new Date(
        this.selfAssessmentT3FilterData.nextassessmentDue
      );
    }
    this.selfAssessmentT3Filter.lbcmImpact =
      this.selfAssessmentT3FilterData.lbcmImpact;

    this.selfAssessmentT3Filter.lbgImpact =
      this.selfAssessmentT3FilterData.lbgImpact;

    this.selfAssessmentT3Filter.rfbImpact =
      this.selfAssessmentT3FilterData.rfbImpact;
    this.selfAssessmentT3Filter.ruleId= this.selfAssessmentT3FilterData.ruleId;
    this.selfAssessmentT3Filter.rulebookRuleId= this.selfAssessmentT3FilterData.rulebookRuleId;
    this.selfAssessmentT3Filter.assessor = this.selfAssessmentT3FilterData.assessor;
    this.fetchSelfAssessmentT3Summary();
    const bodyStyleElement = document.querySelector(
      '.body-style3'
    ) as HTMLDivElement;
    const tableElement = document.querySelector('.table') as HTMLDivElement;

    // Check if the elements exist
    if (bodyStyleElement && tableElement) {
      // Set the width for .body-style and .table
      bodyStyleElement.style.width = this.tableWidthT3 + 'px';
      tableElement.style.width = this.tableWidthT3 + 'px';
      bodyStyleElement.style.overflow = 'auto';
    }
    this.eleRef.nativeElement.style.setProperty(
      '--table-min-width',
      this.tableWidthT3 + 'px'
    );
  }
  redirectLink(id: number) {
    let link = '/self-assessment/details/self/3/' + id + '';
    const navigationExtras: NavigationExtras = {
      state: { idList: this.idList }
    };
   this.router.navigate([link], navigationExtras);
  }
  selectItem(event: any, id: number): void {
    if (event.target.checked === true) {
      this.selectedItems.push(id);
    } else {
      const index = (this.selectedItems as number[]).indexOf(id);
      if (index >= 0) {
        (this.selectedItems as number[]).splice(index, 1);
      }
    }
    this.selectData.emit(this.selectedItems);
  }
  handler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
    this.endIndexUpdate.emit(this.endIndex);
  }

  public scrollRight(): void {
    this.tableContentT3.nativeElement.scrollTo({
      left: this.tableContentT3.nativeElement.scrollLeft + 150,
      behavior: 'smooth',
    });
  }

  public scrollLeft(): void {
    this.tableContentT3.nativeElement.scrollTo({
      left: this.tableContentT3.nativeElement.scrollLeft - 150,
      behavior: 'smooth',
    });
  }
  allSelectedItems(event: any, dataList: any) {
    this.selectedItems = this._globalService.allSelectedItems(event, dataList);
  }
  changeSaT3TableWidth(
    itemWidth: number,
    isHide: boolean,
    filter: string,
    itemActiveModelT3: ItemActiveModel[]
  ) {
    if (filter == 'OnLoad') {
      if (!isHide) {
        this.tableWidthT3 = this.tableWidthT3 - itemWidth;
        this.eleRef.nativeElement.style.setProperty(
          '--table-min-width',
          this.tableWidthT3 + 'px'
        );
        const bodyStyleElement = document.querySelector(
          '.body-style3'
        ) as HTMLDivElement;
        const tableElement = document.querySelector('.table') as HTMLDivElement;
        // Check if the elements exist
        if (bodyStyleElement && tableElement) {
          // Set the width for .body-style and .table
          bodyStyleElement.style.width = this.tableWidthT3 + 'px';
          tableElement.style.width = this.tableWidthT3 + 'px';
          bodyStyleElement.style.overflow = 'auto';
        }
      }
    } else {
      if (isHide) {
        this.tableWidthT3 = this.tableWidthT3 + itemWidth;
        this.eleRef.nativeElement.style.setProperty(
          '--table-min-width',
          this.tableWidthT3 + 'px'
        );
        const bodyStyleElement = document.querySelector(
          '.body-style3'
        ) as HTMLDivElement;
        const tableElement = document.querySelector('.table') as HTMLDivElement;
        // Check if the elements exist
        if (bodyStyleElement && tableElement) {
          // Set the width for .body-style and .table
          bodyStyleElement.style.width = this.tableWidthT3 + 'px';
          tableElement.style.width = this.tableWidthT3 + 'px';
          bodyStyleElement.style.overflow = 'auto';
        }
      } else if (!isHide) {
        this.tableWidthT3 = this.tableWidthT3 - itemWidth;
        this.eleRef.nativeElement.style.setProperty(
          '--table-min-width',
          this.tableWidthT3 + 'px'
        );
        const bodyStyleElement = document.querySelector(
          '.body-style3'
        ) as HTMLDivElement;
        const tableElement = document.querySelector('.table') as HTMLDivElement;
        // Check if the elements exist
        if (bodyStyleElement && tableElement) {
          // Set the width for .body-style and .table
          bodyStyleElement.style.width = this.tableWidthT3 + 'px';
          tableElement.style.width = this.tableWidthT3 + 'px';
          bodyStyleElement.style.overflow = 'auto';
        }
      }
    }
    MasterHelper.saveOnBrowser(
      this.assesment3Type,
      JSON.stringify(itemActiveModelT3)
    );
  }
  sortSelfAssessment(key: string): void {
    this.selfAssessmentT3Filter.isDesc = !this.selfAssessmentT3Filter.isDesc;
    this.selfAssessmentT3Filter.sortKey = key;
    this.fetchSelfAssessmentT3Summary();
  }
  @Output() totalData = new EventEmitter<{ value1: number, value2: number }>();
  @Input() totalCount: number | undefined;
  @Output() endIndexUpdate = new EventEmitter<number>();
  fetchSelfAssessmentT3Summary() {
    this.selfAssessmentTemplate3Service
      .getSelfAssessmentT3List(this.selfAssessmentT3Filter)
      .subscribe((result: SelfAssessmentT3ViewModel) => {
        this.selfAssessmentList = result.data;
        this.totalCount=result.totalCount;
        this.endIndex =
        this.endIndex > result.totalCount ? result.totalCount : this.endIndex;
        const value1 = this.endIndex;
        const value2 = result.totalCount;
        this.totalData.emit({ value1, value2 } );
        this.idList = this.getIdList();
      });
  }
  getIdList(): number[] {
    return this.selfAssessmentList.map(item => item.id);
  }
}
